// 권한 정보 관리
export const authKeys = {
  all: () => ["auth"],

  // [GET] 권한 정보 가져오기
  authData: () => [...authKeys.all(), "authData"],
};
